/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React, { useState, useEffect } from "react";
import "./resend-otp.module.css";
import { triggerSendOtp } from "../../util";
import { RESEND_OTP } from "../../../../../constants";
import { useSelector } from "react-redux";
import get from 'lodash/get';

export const ResendOtp = ({
  resendOtpLabel,
  resendOtpInLabel,
  setResponse,
  setApi,
  phoneNumber = "",
  email = "",
  countryIso = "",
}) => {
  const [countDown, setCountDown] = useState(30);
  const [displayResendOtpInLabel, setResendOtpInLabel] = useState(true);
  const resendOtpText = resendOtpLabel || RESEND_OTP;
  const sketchesHost = useSelector(state => get(state, ['qt', 'config', 'sketches-host'], ''));

  let resendOtpInText = `Resend OTP in 0: ${countDown}`;

  useEffect(() => {
    let timer;
    if (countDown !== null) {
      timer = setInterval(() => {
        setCountDown((prevCountDown) => prevCountDown - 1);
      }, 1000);
    }
    if (countDown === 0) {
      setResendOtpInLabel(false);
    }
    return () => clearInterval(timer);
  }, [countDown]);

  if (resendOtpInLabel) {
    const resendLabelShortCode = [{ code: "[resend-otp-timer]", value: `0: ${countDown}` }];
    resendLabelShortCode.map((item) => (resendOtpInText = resendOtpInLabel.replace(item.code, item.value)));
  }

  const triggerResendOtp = async () => {
    const sendOtpProps = { phoneNumber: phoneNumber, email: email, countryIso: countryIso, sketchesHost };
    const otpResponse = await triggerSendOtp(sendOtpProps);
    setResponse(otpResponse);
    setApi(phoneNumber ? "send-otp-mobile" : "send-otp-email");

    if (otpResponse === 200) {
      setResendOtpInLabel(true);
      setCountDown(30);
    }
  };

  return (
    <div
      styleName={displayResendOtpInLabel ? "action-label" : "action-label cursor-pointer"}
      className={!displayResendOtpInLabel ? "auth--text-color" : ""}
      onClick={() => !displayResendOtpInLabel && triggerResendOtp()}
    >
      {displayResendOtpInLabel ? resendOtpInText : resendOtpText}
    </div>
  );
};
